var angular = require('angular');
var _module = angular.module('benoit');
var config = require('config');
var _ = require('lodash');

_module.service('$agentNavStore', [
    '$log',
    '$http',
    '$q',

    function $agentNavStore($log, $http, $q) {
        function AgentNavStore() {
            this.navs = [];
            this.grouped_navs = [];
            this.loading = true;

            this._fetch();
        }

        // Private Functions

        /*
        Fetches the navs from listreports
        */
        AgentNavStore.prototype._fetch = function _fetch() {
            var _this = this;
            var url = config.listreportsUrl + '/v1/agent-navs';

            return $http.get(url)
            .then(function setNavs(response) {
                _this.navs.length = 0;
                _this.navs.push.apply(_this.navs, _this._sortFlat(response.data.data));
                _this._groupNavs(_.cloneDeep(_this.navs));

                return _this.navs;
            })
            .catch(function onError(err) {
                $log.error('$agentNavStore -> AgentNavStore -> _fetch -> Error', err);
            })
            .finally(function () {
                _this.loading = false;
            });
        };

        /*
        Sorts everything as if it was in a tree
        list but flattened out.
        */
        AgentNavStore.prototype._sortFlat = function _sortFlat(navs) {
            /*
            Group nav items by parentId.
            */
            var grouped = _.groupBy(navs, 'parentId');

            /*
            Order each group by the order property on
            the items in the collection.
            */
            Object.keys(grouped).forEach(function (key) {
                grouped[key] = _.orderBy(grouped[key], ['order'], ['asc']);
            });

            /*
            Set our default list based on the
            root nav items (null).
            */
            var orderedList = grouped['null'] || [];
            delete grouped['null'];

            /*
            Create a list of all the id's from the
            list of navs passed in.'
            */
            var ids = navs.reduce(function (result, nav) {
                result.push(nav.id);
                return result;
            }, []);

            /*
            Find all the groups where their parentId
            doesnt exist in ids. We need to manually put
            these into the array because their parent no
            longer exists.
            */
            var orphanedGroups = Object.keys(grouped).reduce(function (result, key) {
                if(!~ids.indexOf(key)) {
                    result.push.apply(result, grouped[key]);
                    delete grouped[key];
                }

                return result;
            }, []);

            orderedList.push.apply(orderedList, orphanedGroups);

            /*
            Put the rest of the groups under their parent.
            */
            var keys = Object.keys(grouped);

            while(keys.length) {
                var key = keys.shift();
                var index = _.findIndex(orderedList, { id: key });

                if(~index) {
                    orderedList.splice.apply(orderedList, _.concat([(index + 1), 0], grouped[key]));
                } else {
                    keys.push(key);
                }
            }

            return orderedList;
        };

        /*
        Merges the navs into a parent child state
        rather then a flat collection.
        */
        AgentNavStore.prototype._groupNavs = function _groupNavs(navs) {
            /*
            Group nav items by parentId.
            */
            var grouped = _.groupBy(navs, 'parentId');

            /*
            Order each group by the order property on
            the items in the collection.
            */
            Object.keys(grouped).forEach(function (key) {
                grouped[key] = _.orderBy(grouped[key], ['order'], ['asc']);
            });

            /*
            Set our default list based on the
            root nav items (null).
            */
            var orderedList = grouped['null'] || [];
            delete grouped['null'];

            /*
            Start building the parent child
            collection.
            */
            orderedList.forEach(function (nav) {
                addChildren(nav, grouped);
            });

            /*
            Set the final value and return.
            */
            this.grouped_navs.length = 0;
            this.grouped_navs.push.apply(this.grouped_navs, orderedList);

            return this.grouped_navs;


            /*
            Recursively adds all the children under
            their respective parent;
            */
            function addChildren(nav, grouped) {
                var keys = Object.keys(grouped);

                if(~keys.indexOf(nav.id)) {
                    nav.children = grouped[nav.id];
                    delete grouped[nav.id];

                    nav.children.forEach(function (nav) {
                        addChildren(nav, grouped);
                    });
                }

                return nav;
            }

        };


        // Public Functions

        /*
        Get a single page. If it doesn't exist we will
        try to fetch it from the server.'
        */
        AgentNavStore.prototype.get = function get(id) {
            if(!id) {
                return $q.reject(new Error('You must pass in an id.'));
            }

            var nav = _.find(this.navs, { id: id });

            if(nav) return $q.when(nav);

            var url = config.listreportsUrl + '/v1/agent-navs/' + id;

            return $http.get(url)
            .then(function onSuccess(response) {
                return response.data.data;
            })
            .catch(function onError(err) {
                $log.error('$agentNavStore -> AgentNavStore -> get -> Error', err);

                throw err;
            });
        };


        return new AgentNavStore();
    }
]);
